module.exports = __webpack_public_path__ + "media/FIVEx_tutorial_1.244b0936.mp4";